<template>
    <div v-html="renderedMath" class="d-flex justify-content-center align-items-center"></div>
  </template>
  
  <script>
  export default {
    props: ['formula'],
    computed: {
      renderedMath() {
        return `\\(${this.formula}\\)`; // usa `\\[` y `\\]` si quieres que se vea centrado como bloque
      }
    },
    updated() {
      this.typeset();
    },
    mounted() {
      this.typeset();
    },
    methods: {
      typeset() {
        if (window.MathJax) {
          window.MathJax.typesetPromise && window.MathJax.typesetPromise();
        }
      }
    }
  }
  </script>
  